module.exports = __webpack_public_path__ + "img/topicEnvironment.04f2a07d.png";